import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import NewPasswordForm from '../Login/NewPasswordForm';
import { BaseButton, useT } from '@repo/common';
import { ReactComponent as InfoIcon } from '@repo/common/assets/icons/20px/icon_20px_info_filled.svg';

import { verifyPassword } from '../../../../api/user/user.api';

const ConfirmPasswordForm = ({ onSuccess }) => {
  const t = useT();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [showPasswordError, setShowPasswordError] = useState(false);

  const handlePasswordChange = (value) => {
    setPassword(value);
    if (showPasswordError) setShowPasswordError(false);
  };

  const handleContinue = async () => {
    setIsLoading(true);
    try {
      await verifyPassword(password);
      onSuccess?.();
    } catch (err) {
      console.error('비밀번호 확인 실패', err);
      setShowPasswordError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className='flex flex-col items-start tabletH:items-center justify-center w-full tabletH:w-[460px] p-0 tabletH:p-10 tabletH:pb-[120px]'>
      <div className='flex flex-col items-start tabletH:items-center gap-1 pb-6 tabletH:pb-10 w-full'>
        <div className='typo-b16Strong tabletH:typo-title2 text-text-primary'>
          {t('Delete your account?', '계정을 삭제하시겠어요?')}
        </div>
        <div className='typo-title1 tabletH:typo-h5 text-text-primary'>
          {t('Confirm your password', '비밀번호를 확인해 주세요')}
        </div>
      </div>

      <div className='w-full tabletH:pb-10 flex flex-col gap-2'>
        <NewPasswordForm
          isDeleteAccount
          onPasswordChange={handlePasswordChange}
        />
        {showPasswordError && (
          <div className='flex gap-0.5 text-text-failed typo-b14Strong'>
            <InfoIcon />
            {t('Incorrect password. Let’s try again.', '비밀번호가 올바르지 않습니다. 다시 시도해 주세요.')}
          </div>
        )}
      </div>

      <div
        className='flex flex-col items-start gap-1 w-full
        fixed bottom-0 left-0 p-4 bg-grayscale-gray00 border-t border-grayscale-gray02 tabletH:border-none
        tabletH:static tabletH:px-0 tabletH:pb-0 tabletH:bg-transparent'
      >
        <BaseButton
          hideIcon
          width='100%'
          isLoading={isLoading}
          isDisabled={!password}
          onClick={handleContinue}
        >
          {t('Continue', '계속하기')}
        </BaseButton>
        <BaseButton
          type='text_basic'
          hideIcon
          width='100%'
          borderclass='border-none'
          onClick={() => navigate(-1)}
        >
          {t('cancel', '취소')}
        </BaseButton>
      </div>
    </div>
  );
};

export default ConfirmPasswordForm;
